import { CustomerNewsletterPreferences } from '../AccountTypes';
import { ConfirmationOrder } from './ConfirmationTypes';
import { ImagePathWithRenditions } from '../ImageTypes';

export enum CheckoutStatus {
  UNKNOWN = 'UNKNOWN',
  ERROR = 'ERROR',
  INITIALIZING = 'INITIALIZING',
  INITIALIZED = 'INITIALIZED',
  CHECKING_OUT = 'CHECKING_OUT',
  DONE = 'DONE',
}

export type CheckoutInitState = {
  hrefCheckout?: string;
  readyForCheckout?: boolean;
};

export type CheckoutInitSetState = {
  basketId: string;
  readyForCheckout: boolean;
};

export type CheckoutState = {
  state: CheckoutStatus;
  initResponse?: CheckoutInitState;
  confirmationError?: string;
  confirmationOrder?: ConfirmationOrder;
  confirmationIsCollectStore: boolean;
  newsletterPreferences?: CustomerNewsletterPreferences;
  hasRegistration?: boolean;
};

export type CheckoutConfiguration = {
  creditCardSavingLegalMessage: string;
  disableGuestLoginForRegisteredUser: boolean;
  displayAssetFooter: boolean;
  prominentGuestCTA: boolean;
  registrationForm: {
    sectionTitle?: string;
    showAddress: boolean;
    showDateOfBirth: boolean;
    showDepartmentName: boolean;
    showInvoiceCheckbox: boolean;
    showMobilePhoneNumber: boolean;
    showNewsletterCheckbox: boolean;
    dateOfBirthExplanationText?: string;
  };
  deliveryForm: {
    eVoucherTitle: string;
    collectInStorePromiseMsg: string;
    hideInvoice: boolean;
    singleDeliveryMessage: string;
    showMobilePhoneNumber: boolean;
  };
  voucherCodeCollapsed: boolean;
  footerImage?: ImagePathWithRenditions;
  termsUrl?: string;
  payPalInfoMessage?: string;
};

export type CheckoutHeaderTopLink = {
  linkName: string;
  linkPath: string;
  target: string;
  hideOnMobile: boolean;
};

export type CheckoutHeaderConfiguration = {
  logo: {
    image: ImagePathWithRenditions;
    link: string;
  };
  topLinks: Array<CheckoutHeaderTopLink>;
};

export type CheckoutLoginResponse = {
  basketId: string;
  readyForCheckout: boolean;
};
